import React from "react";
import AdminInsolvencyCasePage from "./AdminInsolvencyCasePage";

const AdminSakthiGaneshPage = () => (
  <AdminInsolvencyCasePage
    slug="sakthiganesh"
    title="Sakthi Ganesh Textiles - Content Management"
    color="#f5576c"
  />
);

export default AdminSakthiGaneshPage;
